import { createContext } from "react";

export const DispatchContext = createContext((state = "", action = {}) => {});
